import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "resourceLibrary" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "imagecont" }

import { ElTree } from 'element-plus'
import { ref, onMounted } from 'vue'
import { createFolder, getFolderList } from '@/api/affairs'
// @ts-ignore
import myUpload from './myUpload.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'resourceLibrary',
  setup(__props) {

const folderActiveId = ref('')
const data = ref([
    {
        id: '',
        label: '我的空间',
        children: [

        ],
    },
    {
        id: 1,
        label: '我的字体',
        children: [

        ],
    },
])
onMounted(() => {
    getResourceLibrary('', '')
})
const getResourceLibrary = (id, node) => {
    getFolderList({ parent_folder_id: id || '' }).then(res => {
        if (id == '') {
            data.value[0].children = res.data.data.map(item => ({
                id: item.id,
                label: item.name,
                children: []
            }))
        } else {
            node.children = res.data.data.map(item => ({
                id: item.id,
                label: item.name,
                children: []
            }))
        }
    })
}
const handleNodeClick = (node) => {
    getResourceLibrary(node.id, node)
    folderActiveId.value = node.id
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElTree), {
        style: {"max-width":"600px"},
        data: data.value,
        class: "resourceLibrary-tree",
        onNodeClick: handleNodeClick
      }, null, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(myUpload, {
          id: folderActiveId.value,
          ref: "myUploadRef"
        }, null, 8, ["id"])
      ])
    ])
  ]))
}
}

})